import axios from 'axios';


const client = () =>
{
    const defaultOptions = {
        headers:
        {
            'content-type': 'multipart/form-data',
        }
    };

    return {
        get: (url, options = {}) => axios.get(url,
        {
            ...defaultOptions,
            ...options
        }),
        post: function(url, params, options = {})
        {
            let data = new FormData();
            for (var key in params)
            {
                if (params[key] == null) continue;
                var type = typeof params[key];
                if (type.toLowerCase() == 'object' && typeof params[key].length != 'undefined')
                {
                    for (var i = 0; i < params[key].length; i++)
                    {
                        data.append(key + '[]', params[key][i]); //, params[key][i].name);
                    }
                }
                else if (type.toLowerCase() == 'object')
                {
                    data.append(key, params[key], params[key].name);
                }
                else
                {
                    data.append(key, params[key]);
                }
            }
            return axios.post(url, data,
            {
                ...defaultOptions,
                ...options
            });
        },
        put: (url, data, options = {}) => axios.put(url, data,
        {
            ...defaultOptions,
            ...options
        }),
        delete: (url, options = {}) => axios.delete(url,
        {
            ...defaultOptions,
            ...options
        }),
    };
};

export default client()


// WEBPACK FOOTER //
// ./src/lib/AxApi.js